export default "__VITE_ASSET__f80730f7__"